import {
    IconButton,
    Menu,
    MenuButton,
    Portal,
    Tooltip,
} from '@chakra-ui/react';
import { MenuList, MenuItem } from '@/components/v4';
import { useSelector } from 'react-redux';
import { BsThreeDotsVertical } from 'react-icons/bs';

const ActionMenu = ({ actionItems, menuLabel = 'Action Menu' }) => {
    const { darkMode } = useSelector((state) => state.settings);
    return (
        <Menu>
            <Tooltip label={menuLabel}>
                <MenuButton
                    as={IconButton}
                    variant="ghost"
                    aria-label="Menu"
                    icon={
                        <BsThreeDotsVertical
                            fill={darkMode ? 'white' : 'black'}
                        />
                    }
                    color={darkMode ? 'white' : 'gray.700'}
                    _hover={{
                        bg: darkMode ? 'whiteAlpha.200' : 'blackAlpha.100',
                    }}
                    _active={{
                        bg: darkMode ? 'whiteAlpha.300' : 'blackAlpha.200',
                    }}
                    _focus={{ boxShadow: 'none' }}
                />
            </Tooltip>
            <Portal>
                <MenuList>
                    {actionItems?.map((item, index) => (
                        <MenuItem
                            key={index}
                            icon={
                                item.icon ? (
                                    <item.icon style={{ fontSize: '1rem' }} />
                                ) : null
                            }
                            onClick={item.onClick}
                            {...(item.dataAttributes || {})}>
                            {item.label}
                        </MenuItem>
                    ))}
                </MenuList>
            </Portal>
        </Menu>
    );
};

export default ActionMenu;
